var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8359 12.5234C16.7969 12.3828 16.8828 12.1875 16.9648 12.0469C16.9899 12.005 17.0173 11.9646 17.0469 11.9258C17.7485 10.8831 18.1239 9.65519 18.125 8.39844C18.1367 4.79688 15.0977 1.875 11.3398 1.875C8.0625 1.875 5.32812 4.10547 4.6875 7.06641C4.59166 7.50527 4.54321 7.95314 4.54297 8.40234C4.54297 12.0078 7.46484 15.0078 11.2227 15.0078C11.8203 15.0078 12.625 14.8281 13.0664 14.707C13.5078 14.5859 13.9453 14.4258 14.0586 14.3828C14.1747 14.339 14.2978 14.3165 14.4219 14.3164C14.5573 14.3159 14.6914 14.3425 14.8164 14.3945L17.0313 15.1797C17.0798 15.2002 17.1311 15.2134 17.1836 15.2188C17.2665 15.2188 17.346 15.1858 17.4046 15.1272C17.4632 15.0686 17.4961 14.9891 17.4961 14.9063C17.4934 14.8705 17.4868 14.8351 17.4766 14.8008L16.8359 12.5234Z",
    stroke: "#E46869",
    strokeWidth: 1.4375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59606 9.0625C2.08372 9.98291 1.83589 11.0271 1.87994 12.0795C1.92399 13.132 2.25821 14.1518 2.84567 15.0262C2.9359 15.1625 2.98668 15.268 2.97106 15.3387C2.95543 15.4094 2.50504 17.7555 2.50504 17.7555C2.49421 17.8104 2.49832 17.8672 2.51694 17.9199C2.53556 17.9727 2.56801 18.0195 2.6109 18.0555C2.66813 18.1011 2.73929 18.1256 2.81246 18.125C2.85156 18.1251 2.89026 18.1171 2.92613 18.1016L5.12184 17.2422C5.27296 17.1826 5.44154 17.1854 5.59059 17.25C6.33043 17.5383 7.1484 17.7188 7.96676 17.7188C9.06491 17.7199 10.1438 17.4303 11.0937 16.8793",
    stroke: "#E46869",
    strokeWidth: 1.4375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.36ca3d2274ddcec1027561c4afd9aaf2.svg";
export { ForwardRef as ReactComponent };